import AppConstants from "../config/app.constants";

let ContactRequestService = function ($http, $q) {

    let contactRequest = (branchId, routeId, locationId, startDate, endDate, isCompleted, offset, limit) => {
        return $http
            .get(AppConstants.api + `/contact-request/contact-request`, {
                params: { branchId, routeId, locationId, startDate, endDate, isCompleted, limit, offset }
            })
            .then((res) => {
                return res.data
            })
    }

    let exportContactRequest = (branchId, routeId, locationId, startDate, endDate, isCompleted) => {
        return $http
            .post(AppConstants.api + `/contact-request/export-contact-request`, {
                branchId, routeId, locationId, startDate, endDate, isCompleted
            })
            .then((res) => {
                return res.data
            })
    }

    let routesAndLocationList = (branchId) => {
        return $http
            .get(AppConstants.api + `/contact-request/routes-and-location-list`, {
                params: { branchId }
            })
            .then((res) => {
                return res.data
            })
    }

    let markCompleteContactRequest = (contactRequestId, completedByUserId) => {
        return $http
            .post(AppConstants.api + `/contact-request/mark-complete-contact-request`, {
                contactRequestId, completedByUserId
            })
            .then((res) => {
                return res.data
            })
    }

    return {
        contactRequest,
        exportContactRequest,
        routesAndLocationList,
        markCompleteContactRequest
    };
}

ContactRequestService.$inject = ['$http', '$q'];

export default ContactRequestService;


// WEBPACK FOOTER //
// ./client/app/services/contact-request.service.js